/**
 *  @class
 *  @function BackgroundVideo
 */
if (!customElements.get('background-video')) {
	class BackgroundVideo extends HTMLElement {
		constructor() {
			super();

			this.tl = false;
			this.splittext = false;
			this.paused = false;
			this.muted = true;

			this.playToggle = this.querySelector('[data-video-play-toggle]');
			this.soundToggle = this.querySelector('[data-video-sound-toggle]');
		}

		connectedCallback() {
			let _this = this;

			if (
				document.body.classList.contains('animations-true') &&
				typeof gsap !== 'undefined'
			) {
				this.prepareAnimations();
			}

			this.video_container = this.querySelector('.background-video__iframe');

			if (!this.video_container) return;

			const iframe = this.video_container.querySelector('iframe');
			const video = this.video_container.querySelector('video');

			/*
			 * IFRAME
			 * Keep original autoplay behaviour.
			 * Do NOT send mute command here.
			 */
			if (iframe) {
				iframe.onload = function () {
					_this.videoPlay();
				};
			}

			/*
			 * Shopify hosted MP4
			 * Force autoplay + muted.
			 */
			if (video) {
				video.muted = true;
				video.defaultMuted = true;
				video.autoplay = true;
				video.playsInline = true;

				const playPromise = video.play();

				if (playPromise !== undefined) {
					playPromise.catch(() => {
						// Browser may delay autoplay.
					});
				}
			}

			/*
			 * Play / Pause
			 */
			if (this.playToggle) {
				this.playToggle.addEventListener(
					'click',
					this.setupPlayControlEvents.bind(this)
				);
			}

			/*
			 * Sound
			 */
			if (this.soundToggle) {
				this.soundToggle.addEventListener(
					'click',
					this.setupSoundControlEvents.bind(this)
				);
			}

			this.updateSoundControl();
		}

		disconnectedCallback() {
			if (
				document.body.classList.contains('animations-true') &&
				typeof gsap !== 'undefined'
			) {
				if (this.tl) {
					this.tl.kill();
				}

				if (this.splittext) {
					this.splittext.revert();
				}
			}
		}

		/*
		 * PLAY / PAUSE
		 */
		setupPlayControlEvents() {
			if (this.paused) {
				this.videoPlay();

				if (this.playToggle) {
					this.playToggle.classList.remove('paused');
				}
			} else {
				this.videoPause();

				if (this.playToggle) {
					this.playToggle.classList.add('paused');
				}
			}
		}

		videoPlay() {
			setTimeout(() => {
				const provider = this.video_container.dataset.provider;

				if (provider === 'youtube') {
					const iframe = this.video_container.querySelector('iframe');

					if (iframe) {
						iframe.contentWindow.postMessage(
							JSON.stringify({
								event: 'command',
								func: 'playVideo',
								args: []
							}),
							'*'
						);
					}
				}

				else if (provider === 'vimeo') {
					const iframe = this.video_container.querySelector('iframe');

					if (iframe) {
						iframe.contentWindow.postMessage(
							JSON.stringify({
								method: 'play'
							}),
							'*'
						);
					}
				}

				else if (provider === 'hosted') {
					const video = this.video_container.querySelector('video');

					if (video) {
						video.play().catch(() => {});
					}
				}

				this.paused = false;

			}, 10);
		}

		videoPause() {
			setTimeout(() => {
				const provider = this.video_container.dataset.provider;

				if (provider === 'youtube') {
					const iframe = this.video_container.querySelector('iframe');

					if (iframe) {
						iframe.contentWindow.postMessage(
							JSON.stringify({
								event: 'command',
								func: 'pauseVideo',
								args: []
							}),
							'*'
						);
					}
				}

				else if (provider === 'vimeo') {
					const iframe = this.video_container.querySelector('iframe');

					if (iframe) {
						iframe.contentWindow.postMessage(
							JSON.stringify({
								method: 'pause'
							}),
							'*'
						);
					}
				}

				else if (provider === 'hosted') {
					const video = this.video_container.querySelector('video');

					if (video) {
						video.pause();
					}
				}

				this.paused = true;

			}, 10);
		}

		/*
		 * SOUND
		 */
		setupSoundControlEvents(event) {
			event.preventDefault();
			event.stopPropagation();

			if (this.muted) {
				this.videoUnmute();
			} else {
				this.videoMute();
			}
		}

		videoMute() {
			const provider = this.video_container.dataset.provider;

			if (provider === 'youtube') {
				const iframe = this.video_container.querySelector('iframe');

				if (iframe) {
					iframe.contentWindow.postMessage(
						JSON.stringify({
							event: 'command',
							func: 'mute',
							args: []
						}),
						'*'
					);
				}
			}

			else if (provider === 'vimeo') {
				const iframe = this.video_container.querySelector('iframe');

				if (iframe) {
					iframe.contentWindow.postMessage(
						JSON.stringify({
							method: 'setVolume',
							value: 0
						}),
						'*'
					);
				}
			}

			else if (provider === 'hosted') {
				const video = this.video_container.querySelector('video');

				if (video) {
					video.muted = true;
				}
			}

			this.muted = true;
			this.updateSoundControl();
		}

		videoUnmute() {
			const provider = this.video_container.dataset.provider;

			if (provider === 'youtube') {
				const iframe = this.video_container.querySelector('iframe');

				if (iframe) {
					iframe.contentWindow.postMessage(
						JSON.stringify({
							event: 'command',
							func: 'unMute',
							args: []
						}),
						'*'
					);
				}
			}

			else if (provider === 'vimeo') {
				const iframe = this.video_container.querySelector('iframe');

				if (iframe) {
					iframe.contentWindow.postMessage(
						JSON.stringify({
							method: 'setVolume',
							value: 1
						}),
						'*'
					);
				}
			}

			else if (provider === 'hosted') {
				const video = this.video_container.querySelector('video');

				if (video) {
					video.muted = false;
				}
			}

			this.muted = false;
			this.updateSoundControl();
		}
		updateSoundControl() {
			if (!this.soundToggle) return;

			const soundOn = this.soundToggle.querySelector(
				'.background-video__controls-sound-on'
			);

			const soundOff = this.soundToggle.querySelector(
				'.background-video__controls-sound-off'
			);

			if (this.muted) {
				// Sound Off
				if (soundOn) {
					soundOn.style.setProperty('display', 'none', 'important');
				}

				if (soundOff) {
					soundOff.style.setProperty('display', 'flex', 'important');
				}

				this.soundToggle.setAttribute('aria-label', 'Turn sound on');

			} else {
				// Sound On
				if (soundOn) {
					soundOn.style.setProperty('display', 'flex', 'important');
				}

				if (soundOff) {
					soundOff.style.setProperty('display', 'none', 'important');
				}

				this.soundToggle.setAttribute('aria-label', 'Mute video');
			}
		}
		

		/*
		 * ORIGINAL ANIMATIONS
		 */
		prepareAnimations() {
			let section = this;

			section.tl = gsap.timeline({
				scrollTrigger: {
					trigger: section,
					start: 'top center'
				}
			});

			document.fonts.ready.then(function () {

				gsap.set(
					section.querySelectorAll(
						'.subheading, .background-video__content--heading, .rte p, .video-lightbox-modal__opener button'
					),
					{
						visibility: 'visible'
					}
				);

				section.splittext = new SplitText(
					section.querySelectorAll(
						'.background-video__content--heading, .rte p'
					),
					{
						type: 'lines',
						linesClass: 'line-child'
					}
				);

				section.mask = new SplitText(
					section.querySelectorAll(
						'.background-video__content--heading, .rte p'
					),
					{
						type: 'lines',
						linesClass: 'line-parent'
					}
				);

				section.tl.fromTo(
					section.querySelector('.subheading'),
					{
						opacity: 0
					},
					{
						duration: 0.25,
						opacity: 1
					}
				);

				section.tl.from(
					section.querySelectorAll(
						'.background-video__content--heading .line-child'
					),
					{
						duration: 0.75,
						yPercent: 120,
						stagger: 0.1,
						rotation: '2deg'
					},
					'>-=0.3'
				);

				section.tl.from(
					section.querySelectorAll('.rte p .line-child'),
					{
						duration: 0.5,
						yPercent: 120,
						stagger: 0.02,
						rotation: '2deg'
					},
					'>-=0.3'
				);

				section.tl.fromTo(
					section.querySelector(
						'.video-lightbox-modal__opener button'
					),
					{
						autoAlpha: 0
					},
					{
						duration: 0.5,
						autoAlpha: 1
					},
					'>-=0.3'
				);
			});
		}
	}

	customElements.define('background-video', BackgroundVideo);
}